
import {data} from "cheerio/lib/api/attributes";

type order = {
    basicset_id: number;
    id: number;
    order: any;
    offer: any;
    car_code: string;
    order_offer_info:boolean;
    orderstatus:number
};
type parameterKey = keyof BillingParameter;
type formKey = keyof formType;
const columnList: Array<column> = [
    {
        prop: "create_time",
        label: "开单时间",
        width: 80,
    },
    {
        prop: "meet_vehicle",
        label: "接车人",
        width: 80,
    },
    {
        prop: "orderstatustext",
        label: "状态",
        width: 70,
    },
    {
        prop: "progresstext",
        label: "进度",
        width: 60,
    },
    {
        prop: "order_offer_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "order_advance_payment_text",
        label: "预收款",
        width: 80,
    },
    {
        prop: "car_code",
        label: "车牌号码",
        width: 90,
    },
    {
        prop: "category_name",
        label: "品牌车型",
        width: 80,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 80,
    },
    {
        prop: "send_for_repair",
        label: "送修人",
        width: 80,
    },
    {
        prop: "settlement_notes",
        label: "工单备注",
        width: 100,
    },
    {
        prop: "basicset_name",
        label: "服务类型",
        width: 80,
    },
];
const dialogTitleColumn: Array<{
    label: string;
    prop: string;
    is_normal?: boolean;
}> = [
    {
        label: "单据编号：",
        prop: "ordersn",
        is_normal: true,
    },
    {
        label: "状态",
        prop: "settlement_status_text",
    },
    {
        label: "开单时间",
        prop: "create_time_text",
        is_normal: true,
    },
    {
        label: "结算时间",
        prop: "settlement_time_text",
        is_normal: true,
    },
    {
        label: "服务类型",
        prop: "basicset_id_name",
    },
    {
        label: "接车人",
        prop: "meet_vehicle_id_name",
    },
    {
        label: "报价金额",
        prop: "offer_pirce",
    },
    {
        label: "结算金额",
        prop: "settlement_pirce",
    },
    {
        label: "车牌号码",
        prop: "car_code",
    },
    {
        label: "品牌车型",
        prop: "series_name",
    },
    {
        label: "进厂里程",
        prop: "mitplant",
    },
    {
        label: "是否返修",
        prop: "is_rework",
    },
    {
        label: "送修人",
        prop: "send_for_repair",
    },
    {
        label: "手机号码",
        prop: "send_for_repair_phone",
    },

    {
        label: "会员号",
        prop: "user_id",
    },
    {
        label: "昵称",
        prop: "user_nickname",
    },
    {
        label: "保险公司",
        prop: "cicompany_id_name",
    },
    {
        label: "送修单位",
        prop: "units_id_name",
    },
    {
        label: "合作方",
        prop: "partner_id_name",
    },
    {
        label: "结算备注",
        prop: "settlement_notes",
    },
];
const offerColumn: Array<column> = [
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    },
];
const projectColumn: Array<column> = [
    {
        prop: "project_name",
        label: "维修项目报价",
        width: 80,
    },
    ...offerColumn,
];
const partsColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件报价",
        width: 80,
    },
    {
        prop: "mountings_id_encoding",
        label: "规格",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    }
];
const mountingsCostColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件成本",
        width: 80,
    },
    {
        prop: "collar_num",
        label: "领料",
        width: 80,
    },
    {
        prop: "retreat_num",
        label: "退料",
        width: 80,
    },
    {
        prop: "use_num",
        label: "用量",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "cost",
        label: "成本价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
];
const elseCostColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "其他成本",
        width: 80,
    },
    {
        prop: "supplier_id_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "othercosts_costprice",
        label: "金额",
        width: 80,
    },
];
const settlementColumn: Array<column> = [
    {
        prop: "pay_name",
        label: "工单结算",
        width: 80,
    },
    {
        prop: "pay_type_name",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "pay_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "pay_ctime",
        label: "时间",
        width: 80,
    },
];
const elseCostListColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "成本项目",
        width: 120,
    },
    {
        prop: "othercosts_costprice",
        label: "成本",
        width: 120,
    },
    {
        prop: "branch_name",
        label: "成本承担部门",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
];
const costRules = {
    othercosts_name: [
        {
            required: true,
            message: "请输入成本项目",
            trigger: "change",
        },
    ],
    othercosts_costprice: [
        {
            required: true,
            message: "请输入成本",
            trigger: "change",
        },
    ],
    branch_id: [
        {
            required: true,
            message: "请选择成本承担部门",
            trigger: "change",
        },
    ],
    // supplier_id: [
    //     {
    //         required: true,
    //         message: "请选择供应商",
    //         trigger: "change",
    //     },
    // ],
};
const form_rules = {
	service_type_id: [{required: true, message: '必填', trigger: 'blur'}],
	meet_vehicle_id: [{required: true, message: '必填', trigger: 'blur'}],
	// car_brand_id:  [{ required: true, message: '必填', trigger: 'change' }],
	// car_series_id: [{ required: true, message: '必填', trigger: 'change' }],
    car_check_id: [{ required: true, message: '必填', trigger: 'blur' }]
};
const prepareFormRules = {

}
import {
    defineComponent,
    ref,
    reactive,
    inject,
    onMounted,
    watch,
    getCurrentInstance, onActivated,
} from "vue";
import { useRouter,useRoute } from "vue-router";
import { Request } from '@/api/request';
import {
    getOrderCarTabble,
    getOrderCarSelectList,
    getOrderCarRepairunit,
    getCarBrand,
    orderCarExport,
    getConstructors,
    getOrderCarOrderinfo,
    getOthercostsList,
    postAddothercosts,
    postDelothercosts,
    getSupplierList,
    postSetorderstatus,
    getPayQrcode,
    postSetQualityTesting,
    getBasicsetList,
    getCarOne,
    orderAdvancePayment,
    getCheckProjectGroup,
    orderAdvancePaymentList,
    getVinInfo,
    permissionList,
    getAllRepairUnitList,
    getAllPartnerList,
    getSupplierTotalList,
    getOrderCarMountings,
    getSpecialTotalList, workRequiredList, workSettlementExport,
} from "@/api/http";
import { column, formType, BillingParameter,partsFormType } from "@/assets/types/common";
import {Debounce, Throttle} from "@/api/api";
import {ElLoading} from "element-plus";
export default defineComponent({
    name: "Billing",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["接车开单"]);
        const headClass = inject("headClass");
        const router = useRouter();
        const route = useRoute();
        // const { proxy } = (getCurrentInstance() as any);
        let userInfo = ref({} as any);
        //工单预收款专区
        let prepareData = reactive({
            prepareLoading:true,
            prepareLoad:false,
            prepareList:[]
        });
        let getPrepareList = (()=>{
            orderAdvancePaymentList({order_id:currentOrder.value}).then((res:any)=>{
                prepareData.prepareLoading = false;
                prepareData.prepareList = res.content.list;
            });
        });
		// 查找车型信息，并自动填写品牌车型
        let checkVinInfo = (()=>{
			let t = this;
            getVinInfo({vin:form.value.vin}).then((res:any)=>{
				if(res.status == 200){
					let info = res.content;
					// 如果是新增品牌车型，则重新渲染车品牌列表和车系列表
					if(info.is_new == 1){
						getCarBrand({}).then((res: any) => {
						    select.car_brand_data = res?.content?.list || [];
							setTimeout(() => {
								// 选中车品牌
								form.value.car_brand_id = Number(info.car_brand_id);
								// 获取对应品牌的车系
								getCarBrand({
									brand_id: Number(info.car_brand_id),
								}).then((res: any) => {
									select.car_series_data_a = res?.content?.list || [];
									// 选中对应车系
									form.value.car_series_id = Number(info.car_series_id);
								});
							},500)
						});
					}else{
						// 选中车品牌
						form.value.car_brand_id = info.car_brand_id;
						// 获取对应品牌的车系
						getCarBrand({
							brand_id: Number(info.car_brand_id),
						}).then((res: any) => {
							select.car_series_data_a = res?.content?.list || [];
							// 选中对应车系
							form.value.car_series_id = info.car_series_id;
						});
					}
				}
            });
        });
            //
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<order>),
            detailTable = ref([] as Array<any>),
            carInfoTable = ref([] as Array<any>),
            roleList = ref({} as any),
            dialogNavIndex = ref(0),
            constructorDialog = ref(false),
            total = ref(0),
            sheetMustList = reactive([]),
            loading = ref(true),
            currentOrder = ref(0),
			isPrint = ref(false),
			isProject = ref(false),
			isMountings = ref(false),
			form_isload = ref(false),
			form_status = ref(0),
			form_carcode = ref(''),
			qrcodeImgeUrl = ref(''),
            publicImgeUrl = ref(''),
			form_carbrandList = ref([] as any),
			formRef = ref(null),
			form_itemindex = ref(0),
            total_offer_price = ref(''),
            // 筛选
            selectGroup = reactive({
                orderstatus: null,
                project_type_id: null,
                units_id: null,
                partner_id: null,
                meet_vehicle: null,
                car_brand_id: null,
                car_series_id: null,
                search: "",
                start_date: 0,
                end_date: 0,
                status: null,
                date: 0,
            }),
            select = reactive({
                project_type_data: [],
                partner_data: [] as any,
                repairunit_data: [],
                car_brand_data: [],
                car_series_data: [],
                receive_data: [],
                branch_data: [],
                supplier_data: [],
				insurance_data: [],
                car_series_data_a: [],
                car_check_group:[]
            }),
            constructors_data = ref([{
              id:1,
              name:'',
              children:[]
            }]),
            getFirstNowLastDay = ():number => {
              let now = new Date();
              let strLink = "-";
              let year = now.getFullYear();
              let month:any = now.getMonth() + 1;
              let day:any = now.getDate();
              if (month >= 1 && month <= 9) {
                month = "0" + month;
              }
              if (day >= 1 && day <= 9) {
                day = "0" + day;
              }
              let firstDate:string = year + strLink + month + strLink + '01';
              let currentDate = year + strLink + month + strLink + day;
              //var lastDay = this.getLastDay(year, month);
              //var lastDate = year + strLink + month + strLink + lastDay;
              return new Date(currentDate).getTime();
            },
            carInfoDia_show = ref(false),
            preparePayDia_show = ref(false),
            preparePayForm = reactive({
              time:getFirstNowLastDay(),
              income_collection:'',
              payTypeOne:'',
              payTypeTwo:'',
              priceOne:'',
              priceTwo:'',
              desc:''
            }),
            selectList = ref({
              zf: [],
            }),
			form = ref({
				vin: '',
				service_type_id: null,
				car_brand_id: null,
				car_series_id: null,
				car_category_id: null,
				send_for_repair: '',
				units_id: null,
				phone: '',
				partner_id: null,
				insurance_company_id: null,
                cicompany_id:null,
                ccidue:'',
                ccidue_text:"",
                jicompany_id:null,
                compulsory_insurance_due:'',
                compulsory_insurance_due_text:"",
				mitplant: '',
				meet_vehicle_id: null,
                recommend_id:null,
				constructors_id: null,
                constructors_type: null,
                constructors_name:'请选择默认施工人',
                constructors_group:[],
                car_check_id:null
			} as any),
			carList = ref([] as any),
            selectParameter: BillingParameter = reactive({
                page: currentPage.value,
                pagesize: pageSize.value,
            }),
            dialogFormVisible = ref(false),
            orderDetail = ref({} as any),
            // printTabbleHeader = ref(
            //     [] as Array<{
            //         name: string;
            //         value: string;
            //     }>
            // ),
            // 打印的表单
            printData = {
                id: "#print",
                popTitle: "车辆维修工时配件报价单",
                startCallback() {
                },
            };
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                // selectParameter.pagesize = size;
                getTableData();
            },
            constructorChange = (id:Array<number>) => {
              console.log(id)  //输出的是这种数据----{0: 1, 1: 11} 前面的代表1部门2个人；后面的数字代表ID
              if (!id) {
                delete form["constructors_id"];
                  delete form["constructors_type"];
              } else {
                
                  (form.value.constructors_type as any) = id[0];
                  if (id[0] == 1){
                      (form.value.constructors_id as any) = id[1];
                  } else {
                  
                  }
              }
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                // selectParameter.page = page
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
				let data = {
					type:1,
					role_name:'car_order',
				}
				permissionList(data).then((res:any)=>{
					roleList.value = res?.content?.list || 0;
				});
                Request.axiosInstance({
                  url: 'adminapi/OrderCar/list',
                  data:{
					...selectGroup,
					page: currentPage.value,
					pagesize: pageSize.value
				  }
                }).then((res: any) => {
					tableData.value = res?.content?.list || [];
					loading.value = false;
					total.value = res?.content?.total || 0;
                    total_offer_price.value = res?.content?.total_offer_price;
				});
            },
            resetTableData = (()=>{
                currentPage.value = 1;
                getTableData();
            }) ,
            timeChange = (e: any, key: string)=>{
                if (key == "ccidue" || key == "compulsory_insurance_due") {
                    if (e) {
                        e = new Date(e).getTime() / 1000;
                        form.value[key] = e;
                    } else {
                        form.value[key] = e;
                    }
        
                }
            },
            getSelectData = () => {
                getOrderCarSelectList().then((res: any) => {
                    if (res.status == 200) {
                        select.project_type_data = res.content.project_type_data;
                        
                        select.insurance_data = res.content.insurance_data;
                    }

                    //Object.assign(select, res?.content || {});
					// 合作方
					getAllPartnerList({}).then((res:any)=>{
						//select.partner_data = res?.content?.list || [];
						//console.log(select.partner_data)
						for (const re of res.content.list) {
							select.partner_data.push({
								id:re.id,
								name:re.name
							})
						}
						console.log(select.partner_data)
					});
                });
                // getAllRepairUnitList({}).then(()=>{
                //     //select.partner_data = res.content.list;
                // });
                getOrderCarRepairunit({}).then((res: any) => {
                    select.repairunit_data = res?.content?.list || [];
                    console.log(select.repairunit_data)
                });
                getCarBrand({}).then((res: any) => {
                    select.car_brand_data = res?.content?.list || [];
                });
                getConstructors({}).then((res: any) => {
                    select.branch_data = res?.content?.branch || [];
                    select.receive_data = res?.content?.staff || [];
                    constructors_data.value = [{id:1,name:'部门',children:select.branch_data},{id:2,name:"个人",children:select.receive_data}];
                });
                getCheckProjectGroup({}).then((res:any)=>{
                    select.car_check_group = res?.content?.list || [];
                });
				// Request.axiosInstance({
				// 	url: 'adminapi/MobileOrder/get'
				// }).then((res: any) => {
				// })
				
            },
            screenChange = (e: any, key: string): void => {
                if (key == "date") {//Math.floor
                    if (e) {
                        selectGroup.start_date = Math.floor(new Date(e[0]).getTime() / 1000);
                        selectGroup.end_date = Math.floor(new Date(e[1]).getTime() / 1000);
                    } else {
                        selectGroup.start_date = 0;
                        selectGroup.end_date = 0;
                    }
                }
                resetTableData();
            },
            // 列表筛选选择器
            selectChange = (e: number, key: parameterKey): void => {
				currentPage.value = 1;
				if(!e){
                    if (key == "car_brand_id") {
                        selectGroup.car_series_id = null;
					}
                    if (key == "car_brand_id_a"){
                        form.value.car_series_id = null;
                        return;
                    }
                    //if (key == "car_series_id") return;
				}else if (key == "car_brand_id") {
                    selectGroup.car_series_id = null;
					getCarBrand({
						brand_id: Number(selectGroup.car_brand_id),
					}).then((res: any) => {
						select.car_series_data = res?.content?.list || [];
					});
					//return;
				}else if (key == "car_brand_id_a") {
                    form.value.car_series_id = null;
					getCarBrand({
						brand_id: form.value.car_brand_id,
					}).then((res: any) => {
						select.car_series_data_a = res?.content?.list || [];
					});
					return;
				}
                //getTableData();
                resetTableData();
            },
            columnChange = new Throttle().use((item: order, type: number, status: number): void => {
                // if((type == 3&&status ==1)){
                //     confirm("请注意配件要出库");
                // }
                switch (type) {
                    case 0:
                        // router.options.routes.map((item: any) => {
                        //     if (item.name == "CashRegister") {
                        //         item.children.map((sonItem:any)=>{
                        //             if (sonItem.name == "Billing"){
                        //                 sonItem.meta.keepAlive = true;
                        //             }
                        //         });
                        //
                        //     }
                        // });
                        localStorage.setItem("keepAlive", "1");
                        // router.push({
                        //     path: "/cashRegister/billing/billingDetail",
                        //     query: {
                        //         id: item.id,
                        //         orderStatus:item.orderstatus
                        //     },
                        // });
                        localStorage.setItem("order_id", item.id.toString());
                        localStorage.setItem("orderStatus", item.orderstatus.toString());
                        router.push({
                            path: "/cashRegister/billing/billingDetail"
                        });
                        break;
                    case 1:
                        costDialogCarCode.value = item.car_code;
                        addCostForm.value.order_id = item.id;
                        costLoading.value = true;
                        getOthercosts(item.id);
                        costDialogVisible.value = true;
                        isAddCost.value = false;
                        if(addCostFormRef.value){
                            (addCostFormRef.value as any).resetFields();
                        }
                        getSupplierTotalList({status:1}).then((res: any) => {
                            select.supplier_data = res?.content?.list || [];
                        });
                        break;
                    case 2:
                        // if (status == 1){
                        //     if (!item.order_offer_info){
                        //         alert('请输入报价信息');
                        //         return;
                        //     }
                        // }
                        loading.value = true;
                        postSetorderstatus({
                            order_id: item.id,
                            orderstatus: status,
                        }).then((res) => {
                            loading.value = false;
                            resetTableData();
                        });
                        break;
                    case 3:
                        loading.value = true;
                        postSetQualityTesting({
                            order_id: item.id,
                            qualitytesting_status: status,
                        }).then((res:any) => {
                            loading.value = false;
                            resetTableData();
                            if (res.content.isShowTips==1){
                                confirm("请注意还有配件未出库");
                            }
                        });
                        break;
                }
            },3000),
            // columnChange = (item: order, type: number, status: number): void => {
			// 	// if((type == 3&&status ==1)){
            //     //     confirm("请注意配件要出库");
            //     // }
            //     switch (type) {
            //         case 0:
            //             router.push({
            //                 path: "/cashRegister/billing/billingDetail",
            //                 query: {
            //                     id: item.id,
            //                     orderStatus:item.orderstatus
            //                 },
            //             });
            //             break;
            //         case 1:
            //             costDialogCarCode.value = item.car_code;
            //             addCostForm.value.order_id = item.id;
            //             costLoading.value = true;
            //             getOthercosts(item.id);
            //             costDialogVisible.value = true;
            //             isAddCost.value = false;
            //             if(addCostFormRef.value){
            //                 (addCostFormRef.value as any).resetFields();
            //             }
            //             getSupplierTotalList({status:1}).then((res: any) => {
            //                 select.supplier_data = res?.content?.list || [];
            //             });
            //             break;
            //         case 2:
            //             if (status == 1){
            //                 if (!item.order_offer_info){
            //                     alert('请输入报价信息');
            //                     return;
            //                 }
            //             }
            //             postSetorderstatus({
            //                 order_id: item.id,
            //                 orderstatus: status,
            //             }).then((res) => {
            //                 getTableData();
            //             });
            //             break;
            //         case 3:
            //             postSetQualityTesting({
            //                 order_id: item.id,
            //                 qualitytesting_status: status,
            //             }).then((res:any) => {
            //                 getTableData();
            //                 if (res.content.isShowTips==1){
            //                     confirm("请注意还有配件未出库");
            //                 }
            //             });
            //             break;
            //     }
            // },
            //车辆信息
            getCarInfo = ()=> {
              getCarOne({
                car_id:orderDetail.value.car_id
              }).then((res:any)=>{
                if (res.status == 200) {
                  carInfoDia_show.value = true;
                  let info = res.content.list;
                  if(info) {
                    let arr = [[
                      'VIN',
                      info.vin,
                      '品牌车型',
                      info.model_name,
                      '所属单位',
                        info.repairunit,
                      '车身颜色',
                      info.body_color,
                    ],[
                      '车主姓名',
                      info.master_name,
                      '车主手机',
                      info.car_master_phone,
                      '车主身份证',
                      info.idcard,
                      '发动机号',
                      info.engine_number,
                    ],[
                      '下次保养',
                      info.nm_time_text,
                      '保养里程',
                      info.maintenance_mileage,
                      '年检到期',
                      info.aidue_text,
                      '购车时间',
                      info.purchase_time_text,
                    ],[
                      '商业险到期',
                      info.ccidue_text,
                      '交强险到期',
                      info.compulsory_insurance_due_text,
                      '商业险公司',
                      info.cicompany_name,
                      '交强险公司',
                      info.jiompany_name,
                    ],[
                      '商业险保单号',
                      info.cipnumber,
                      '交强险保单号',
                      info.dipolicy_no,
                      '接车提示',
                      info.tips,
                    ]];
                    carInfoTable.value = arr;
                  }
                }
              });
            },
            //工单预收款
            preparePayClick = ()=> {
            //要重置
                preparePayForm.priceOne = '';
                preparePayForm.payTypeOne = '';
                preparePayForm.priceTwo = '';
                preparePayForm.payTypeTwo = '';
                preparePayForm.desc = '';
              preparePayDia_show.value = true;
                getPrepareList();
            },
            //保存预收款
            savePreparePay = ()=> {
                prepareData.prepareLoad = true;
              let result:boolean = checkPrepare();
              if (!result){
                  prepareData.prepareLoad = false;
                return
              }
              let basicset_ids:string = '';
                let payment_prices:string = '';
                if (preparePayForm.payTypeTwo){
                    basicset_ids = preparePayForm.payTypeOne+','+preparePayForm.payTypeTwo;
                    payment_prices = preparePayForm.priceOne+','+preparePayForm.priceTwo;
                }else {
                    basicset_ids = preparePayForm.payTypeOne;
                    payment_prices = preparePayForm.priceOne;
                }
              orderAdvancePayment({
                order_id:currentOrder.value,
                payment_time:preparePayForm.time/1000,
                basicset_id:basicset_ids,
                payment_price:payment_prices,
                payment_remarks:preparePayForm.desc
              }).then((res:any) => {
                  prepareData.prepareLoad = false;
                if (res.status == 202) {
                  preparePayDia_show.value = false;
                }
              });
            },
            //验证收款方式
            checkPrepare = ():boolean=> {
              if (!preparePayForm.priceOne && !preparePayForm.priceTwo){
                alert("收款金额必须大于0");
                return false
              }
              if (preparePayForm.payTypeOne){
                if (!preparePayForm.priceOne || (Number(preparePayForm.priceOne)<=0)){
                  alert("金额必须为大于0的数字");
                  return false
                }
              }
              if (preparePayForm.payTypeTwo){
                if (!preparePayForm.priceTwo || (Number(preparePayForm.priceTwo)<=0)){
                  alert("金额必须为大于0的数字");
                  return false
                }
              }
              if (preparePayForm.priceOne && (Number(preparePayForm.priceOne)<=0)){
                alert("金额必须为大于0的数字");
                return false
              }
              if (preparePayForm.priceTwo && (Number(preparePayForm.priceTwo)<=0)){
                alert("金额必须为大于0的数字");
                return false
              }
              if (preparePayForm.priceOne && !preparePayForm.payTypeOne){
                alert("请选择第一种收款方式");
                return false
              }
              if (preparePayForm.priceTwo && !preparePayForm.payTypeTwo){
                alert("请选择第二种收款方式");
                return false
              }
              return true
            },
            // 点击单据编号触发
            getOrderCarinfo = (order_id: number) => {
              currentOrder.value = order_id;
			  // 获取支付二维码
			  getPayQrcode({order_id}).then((res: any) => {
			  	  if (res.status == 200) {
					  qrcodeImgeUrl.value = res.content.qrcode_image;
                      publicImgeUrl.value = res.content.gong_image;
				  }
			  });
              getOrderCarOrderinfo({order_id}).then((res: any) => {
                if (res.status == 200) {
                  dialogFormVisible.value = true;
                  let info = res.content.list;
                  if (info) {
                    let arr = [[
                      '单据编号',
                      info.ordersn,
                      '状态',
                      info.orderstatustext,
                      '开单时间',
                      info.create_time_text,
                      '结算时间',
                      info.settlement_time_text,
                    ],[
                      '服务类型',
                      info.basicset_id_name,
                      '接车人',
                      info.meet_vehicle_id_name,
                      '报价金额',
                      info.offer_price,
                      '结算金额',
                      info.settlement_pirce,
                    ],[
                      '车牌号码',
                      info.car_code,
                      '品牌车型',
                      info.series_name,
                      '进厂里程',
                      info.mitplant,
                      '是否返修',
                      info.is_rework_text,
                    ],[
                      '送修人',
                      info.send_for_repair,
                      '手机号码',
                      info.send_for_repair_phone,
                      '会员号',
                      info.user_id,
                      '昵称',
                      info.user_nickname,
                    ],[
                      '保险公司',
                      info.cicompany_id_name,
                      '送修单位',
                      info.units_id_name,
                      '合作方',
                      info.partner_id_name,
                      '工单备注',
                      info.settlement_notes,
                    ]];
                    detailTable.value = arr;
                    orderDetail.value = res.content.list;
                    if (res.content.list.order_offer_project.length > 0) {
                      isProject.value = true
                    }
                    if (res.content.list.order_offer_mountings.length > 0) {
                      isMountings.value = true
                    }
                  }
                }
              });
            },
			// 触发打印
            bindPrint = (): void => {
                isPrint.value = true;
                setTimeout(() => {
					isPrint.value = false;
				},1)
            },
            handleClose = (): void => {
                isPrint.value = false;
            },
            getSummariesTable = (param: any): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "order_offer_price"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "order_offer_price") {
                            sums[index] = total_offer_price.value;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            getSummaries = (param: any, type: number): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "othercosts_costprice",
                    "price",
                    "output_value",
                    "pay_price",
                    "num",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
						// 增加合计项
                        switch (type) {
							// 维修项目报价合计
                            case 1:
                                if (column.property == "price") {
                                    sums[index] = orderDetail.value.project_sum_quoted_price;
                                }else if(column.property == "num"){
                                    sums[index] = orderDetail.value.project_sum_num;
                                }  else {
                                    sums[index] = orderDetail.value.project_sum_output_value;
                                }
                                break;
							// 配件报价合计
                            case 2:
                                if (column.property == "output_value") {
                                    sums[index] = orderDetail.value.mountings_sum_output_value;
                                }else if(column.property == "num"){
                                    sums[index] = orderDetail.value.mountings_num_sum;
                                }  else {
                                    sums[index] = orderDetail.value.mountings_sum_quoted_price;
                                }

                                break;
							// 配件成本合计
                            case 3:
                                sums[index] = orderDetail.value.mountings_cost_price;
                                break;
							// 其他成本合计
                            case 4:
                                sums[index] = orderDetail.value.else_cost_price;
                                break;
							// 工单结算合计
                            case 5:
                                sums[index] = orderDetail.value.settlement_pirce;
                                break;
                        }
                        // sums[index] = values.reduce((prev: any, curr: any) => {
                        //     const value = Number(curr);
                        //     if (!isNaN(value)) {
                        //         return prev + curr;
                        //     } else {
                        //         return prev;
                        //     }
                        // }, 0);
                        if(column.property == "num"){
        
                        }else {
                            sums[index] = `¥${sums[index]}`;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            //查询车辆
			_dialogCarcode = (e: any) => {
				form_status.value = (e == '' ? 0 : 1)
				var carcode = carCity.value + e
                
                form.value.car_id = "";
                form.value.vin = "";
                form.value.car_brand_id = "";
                form.value.car_series_id = "";
                form.value.units_id = '';
                form.value.send_for_repair = '';
                form.value.phone = '';
                form.value.partner_id = '';
                form.value.insurance_company_id = '';
				Request.axiosInstance({
					url: 'adminapi/OrderCar/getcar',
					data: {car_code: carcode}
				}).then((res: any) => {
					carList.value = res?.content?.list || []
					form_carcode.value = carcode
				})
			},
            //导出
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
    
                orderCarExport({...selectGroup}).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                        
                    }
                }).catch(() => {
                    loading.close();
                });
            },
			_form_addcar = (index: number) => {
				form_status.value =  (index == null ? 2 : 3);
				form_itemindex.value = index
				form.value.car_code = carCity.value + orderCarCode.value
				if(form_status.value == 3)
				{
				    //选择现有车辆的时候，赋值车id
					let detail = carList.value[index]
					form.value.vin = detail.vin
					form.value.car_brand_id = detail.car_brand_id
					form.value.car_series_id = detail.car_series_id
                    form.value.car_id = detail.id;
					form.value.units_id = detail.units_id;
					if (detail.send_for_repair){
                        form.value.send_for_repair = detail.send_for_repair.send_for_repair;
                        form.value.phone = detail.send_for_repair.phone;
                    }
					if (detail.partner_id){
                        form.value.partner_id = detail.partner_id;
                    }
                    form.value.cicompany_id = detail.cicompany_id;
                    form.value.ccidue = detail.ccidue;
                    form.value.ccidue_text = detail.ccidue_text;
                    form.value.compulsory_insurance_due_text = detail.compulsory_insurance_due_text;
                    form.value.jicompany_id = detail.jicompany_id;
                    form.value.compulsory_insurance_due = detail.compulsory_insurance_due;
                    //form.value.insurance_company_id = detail.insurance_company_id;
                    getCarBrand({
                        brand_id: detail.car_brand_id,
                    }).then((res: any) => {
                        select.car_series_data_a = res?.content?.list || [];
                    });
				}
			}
        // 添加工单
        let addDialogVisible = ref(false),
            isAdd = ref(false),
            carCity = ref("粤S"),
            orderCarCode = ref(""),
            citySelect = ref(false),
            provinceText = ref(""),
            provinceList = [ "京","津","冀","晋","蒙","辽","吉","黑","沪","苏","浙","皖","闽","赣","鲁","豫","鄂","湘","粤","桂","琼","渝","川","贵","云","藏","陕","甘","青","宁","新"],
            cityText = ref(""),
            setCarCity = (value: string) => {
                carCity.value = provinceText.value + value;
                citySelect.value = false;
                provinceText.value = "";
            };
        // 其他成本
        let costTableData = ref([]),
            costDialogCarCode = ref(""),
            costDialogVisible = ref(false),
            costLoading = ref(false),
            isAddCost = ref(false),
            addCostForm = ref({
                order_id: 0,
                othercosts_costprice: "",
                branch_id: null,
                supplier_id: null,
                admin_id: null,
                cpayment: 1,
                othercosts_name: "",
            }),
            addCostFormRef = ref(null),
            deleteElseCost = (othercosts_id: number) => {
                postDelothercosts({ othercosts_id }).then((res: any) => {
                    if (res.status == 202) {
                        costLoading.value = true;
                        getOthercosts(addCostForm.value.order_id);
                    }
                });
            },
            getOthercosts = (order_id: number) => {
                getOthercostsList({ order_id }).then((res: any) => {
                    if (res.status == 200) {
                        costLoading.value = false;
                        costTableData.value = res.content.list;
                    }
                });
            },
            branchCurrentChange = (item:any)=>{
                //console.log(item);{id: 11, name: '美容部'}
                constructorDialog.value = false;
                if (item){
                    form.value.constructors_id = item.id;
                    form.value.constructors_type = 1;
                    form.value.constructors_name = item.name;
                } else {
                
                }
                
            },
            workersSelectionChange = (item:any)=>{
                //console.log(item){id: 3, name: '巨狼养车-厚街店', nickname: '巨狼养车-厚街店'}
                form.value.constructors_group = item;
            },
            comfirmClick = ()=>{
                console.log(form.value.constructors_group.length)
                if (form.value.constructors_group.length>1){
                    form.value.constructors_id = '';
                    for (const constr of form.value.constructors_group) {
                        form.value.constructors_id+=constr.id+',';
                    }
                    form.value.constructors_id = form.value.constructors_id.substring(0,form.value.constructors_id.length-1);
                    form.value.constructors_type = 2;
                    form.value.constructors_name = form.value.constructors_group[0].name+'等'+form.value.constructors_group.length+'人';
                } else if (form.value.constructors_group.length==1){
                    form.value.constructors_id = form.value.constructors_group[0].id;
                    form.value.constructors_type = 2;
                    form.value.constructors_name = form.value.constructors_group[0].name;
                } else{
                    form.value.constructors_id = '';
                    form.value.constructors_type = '';
                    form.value.constructors_name = '请选择默认施工人';
                }
                constructorDialog.value = false;
                console.log(form.value)
            },
            addElseCost = () => {
                (addCostFormRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        postAddothercosts(addCostForm.value).then((res) => {
                            getOthercosts(addCostForm.value.order_id);
                            isAddCost.value = false;
                        });
                    }
                });
            },
			_onSubmit = () => {
                (formRef.value as any).validate((valid: Boolean) => {
                    if (!valid) return
                    form_isload.value = true;
                    let data = {
                        ...form.value,
                        // ccidue:new Date(form.value.ccidue).getTime() / 1000,
                        // compulsory_insurance_due:new Date(form.value.compulsory_insurance_due).getTime() / 1000
                    }
                    // router.options.routes.map((item: any) => {
                    //     if (item.name === "Billing") {
                    //         item.meta.keepAlive = false;
                    //     }
                    // });
                    localStorage.setItem("keepAlive", "2");
                    Request.axiosInstance({
                        url: 'adminapi/OrderCar/postV2',
                        data: data
                    }).then((res: any) => {
                        form_isload.value = false;
                        if (res.status == 202) {
                            addDialogVisible.value = false;
                            localStorage.setItem("order_id", res.content.toString());
                            localStorage.setItem("orderStatus", "0");
                            router.push({
                                path: "/cashRegister/billing/billingDetail"
                            });
                        }
                    })
                })
				
			}
        onMounted(() => {
			let user_info = localStorage.getItem('user_info')
			if(user_info){
				userInfo.value = JSON.parse(user_info)
                //console.log('yonghu--',userInfo.value);
                form.value.meet_vehicle_id = userInfo.value.id;
			}
            if(Object.keys(route.query).length > 0){
                addDialogVisible.value = true;
                 form_status.value = 0;
                  orderCarCode.value = ''
            }
            getTableData();
            getSelectData();
            Request.axiosInstance({
                url: "adminapi/Operate/workSetupList",
                data: {},
            }).then((res: any) => {
                loading.value = false;
                if (res.status == 200) {
                    res.content.list.forEach((item: any, index:any) => {
                        if (item.work_id==8){
                            carCity.value = item.work_return.join('');
                        }
                    });
                }
            });
            workRequiredList({}).then((res:any)=>{
                sheetMustList = res.content.list.value;
            });
            getSpecialTotalList({
            basicset_type: 3
          }).then((res: any) => {
            selectList.value.zf = res.content?.list;
          });
        });
        onActivated(()=>{
            let keepAlive = localStorage.getItem("keepAlive");
            if (Number(keepAlive) == 2){
                resetTableData();
            }else {
            
            }
        });
        watch(isAddCost, (newVlaue, oldValue) => {

        });

        return {
            columnList,
            headClass,
            userInfo,
            pageSize,
            currentPage,
            tableData,
            roleList,
            detailTable,
            total,
            loading,
            selectGroup,
            select,
            dialogFormVisible,
            orderDetail,
            dialogTitleColumn,
            projectColumn,
            partsColumn,
            mountingsCostColumn,
            elseCostColumn,
            settlementColumn,
			printData,
			bindPrint,
			handleClose,
			// printTabbleHeader,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            columnChange,
            getOrderCarinfo,
            getSummaries,
            addDialogVisible,
            isAdd,
            carCity,
            orderCarCode,
            citySelect,
            provinceText,
            provinceList,
            cityText,
            setCarCity,
            elseCostListColumn,
            costTableData,
            costDialogCarCode,
            isAddCost,
            addCostForm,
            addCostFormRef,
            costRules,
            costLoading,
            costDialogVisible,
            deleteElseCost,
            addElseCost,
			_dialogCarcode,
			carList,
			form,
			isPrint,
			isProject,
			isMountings,
			form_isload,
            exportChange,
			form_status,
			form_carcode,
			qrcodeImgeUrl,
			_form_addcar,
			form_rules,
			form_carbrandList,
			formRef,
			form_itemindex,
			_onSubmit,
			constructors_data,
			constructorChange,
			preparePayClick,
			getCarInfo,
			preparePayDia_show,
			preparePayForm,
			selectList,
			savePreparePay,
			carInfoTable,
			carInfoDia_show,
			prepareFormRules,
            dialogNavIndex,
            constructorDialog,
            branchCurrentChange,
            workersSelectionChange,
            comfirmClick,
            //
            prepareData,
            checkVinInfo,
            selectParameter,
            resetTableData,
            sheetMustList,
            publicImgeUrl,
            timeChange,
            screenChange,
            getSummariesTable,
            total_offer_price
        };
    },
});
